import { createFileRoute } from "@tanstack/react-router";

/* eslint-disable-next-line no-restricted-imports */
import { IntercomProvider } from "react-use-intercom";

import SuspendedPage, { PageTopBar } from "./-components/SuspendedPage";
import { INTERCOM_APP_ID } from "@/config/constants";

export const Route = createFileRoute("/_app/accountsuspension")({
  component: AccountSuspension,
});

/**
 * Not a child of `_dashboard`: a suspended account gets a logout bar instead of
 * the dashboard chrome, and its own auto-booting Intercom so the appeal chat is
 * reachable.
 *
 * `IntercomProvider` rather than `@/hooks/useIntercom`, which is the hook only —
 * the same exemption `IntercomProviderInternal` takes.
 */
function AccountSuspension() {
  return (
    <IntercomProvider
      appId={INTERCOM_APP_ID}
      autoBoot
      autoBootProps={{
        hideDefaultLauncher: true,
      }}
    >
      <PageTopBar />
      <SuspendedPage />
    </IntercomProvider>
  );
}
